import './styles.scss';

import React, { HTMLAttributes } from 'react';

interface AppDescriptionDetailProps extends HTMLAttributes<HTMLElement> {
}

export const AppDescriptionDetail = ({children}: AppDescriptionDetailProps) => {

    return (
        <div className='app-description-detail'>
            {children}
        </div>
    );
};
